// tslint:disable

import * as classNames from "classnames";
import * as React from "react";

import "react-google-maps";

import { HTMLDivProps, Text } from "@blueprintjs/core";

import { Classes, MPDButton } from "src/mpd-library";

export interface ISearchBarProps extends HTMLDivProps {
  searchActive: boolean;
  searchValue: string;
  onSearchChange(event: any): void;
  onToggleList(event: any): void;
  onToggleSearchBar(event: any): void;
}

import "./styles.css";

export const SearchBar: React.SFC<ISearchBarProps> = props => {
  const {
    className,
    onToggleList,
    onSearchChange,
    onToggleSearchBar,
    searchActive
  } = props;
  const classes = classNames(
    "search-bar-container",
    searchActive && Classes.ACTIVE,
    className
  );

  return (
    <div className={classes}>
      <MPDButton
        name="right-arrow"
        className="right-arrow"
        onClick={onToggleList}
      />
      <Text className="title"> Saved Layers </Text>
      <MPDButton
        className="search-bar"
        name="geo-search-bar"
        onClick={onToggleSearchBar}
      />
      <input
        className="search-layers"
        placeholder="Search layers"
        type="search"
        onChange={onSearchChange}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/controllers/alerts/components/maps/geo-map/list/search-bar.tsx